import { jsxs, jsx } from "react/jsx-runtime";
import { ResponsiveVideo, CustomPropTypes } from "@zillow/zrs-cms";
import { omit } from "lodash";
import Head from "next/head";
import PropTypes from "prop-types";
import React from "react";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
import StructuredData from "../../components/StructuredData/StructuredData.esm.js";
const BlockVideo = ({
  attrs: {
    loading,
    ...attrs
  },
  index
}) => {
  const isPost = usePlacement() === "post";
  const shouldPreload = loading === "eager" || attrs.autoPlay;
  const attributes = {
    controls: true,
    preload: shouldPreload ? "auto" : "none",
    ...attrs
  };
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    thumbnailUrl: [attrs.poster],
    contentUrl: attrs.src
  };
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsx(StructuredData, { data: structuredData }),
    /* @__PURE__ */ jsx(ResponsiveVideo, { ratio: attributes.width + "/" + attributes.height, className: "exclude-from-algorithmic-darkening", ...omit(attributes, "margin"), ...isPost ? {
      marginBottom: "sm"
    } : attributes.margin }, index),
    shouldPreload && /* @__PURE__ */ jsxs(Head, { children: [
      /* @__PURE__ */ jsx("link", { rel: "preload", href: attrs.poster, as: "image" }),
      /* @__PURE__ */ jsx("link", { rel: "preload", href: attrs.src, as: "video" })
    ] })
  ] });
};
BlockVideo.propTypes = {
  attrs: PropTypes.shape({
    styledWidth: CustomPropTypes.inlineMediaQuery(PropTypes.number)
  }),
  index: PropTypes.number
};
export {
  BlockVideo as default
};
